<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'vehicles'" [businessName]="vm.businessName"
  [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>

<div class="container" *ngIf="!vm.isOpening">
    <form>
  <div class="row pt-4 ">
    <div class="col-md-6 section-header">Permit Renewal</div>
  </div>
  <div>
    <hr class="mt-0 mb-1" />
  </div>
  <div class="row">
    <div class="col-lg-8 col-md">
     

        <div class="pt-2 pb-4">Please select vehicles you want to renew</div>
        <div>

          <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-2"><label>Rego</label></div>
            <div class="col-sm-2"><label>Capacity, Litres</label></div>
            <div class="col-sm-7"><label>Vehicle</label></div>

          </div>
          <hr class="mt-0 mb-2" />
          <div class="row pb-2" *ngFor="let v of vm.vehicles">
            <div class="col-sm-1 text-center ">
              <input type="checkbox" [value]="true" name="isRenew" [(ngModel)]="v.isRenew">
            </div>
            <div class="col-sm-2">{{v.regoNo}}</div>
            <div class="col-sm-2 no-overflow text-right pr-4">{{v.capacity}}</div>
            <div class="col-sm-7 no-overflow ">{{v.vehicleMake}} {{v.vehicleType}} </div>

          </div>

          <div *ngIf="!vm.vehicles || vm.vehicles.length==0">
            No records found
          </div>
        </div>

        <div class="d-flex">

          <div>
            <input class="form-check-input" type="hidden" [ngClass]="{'is-invalid': vm.errors.length>0}">
            <div class="invalid-feedback">
              <div *ngFor="let e of vm.errors">{{e.message}}</div>
            </div>
          </div>
          <div class="ml-auto" *ngIf="vm.vehicles.length > 1">
            <button class="btn btn-link btn-sm" (click)="renewAll()">Select All</button>
          </div>
        </div>

        <div>
          <hr class="mt-0 mb-4" />
        </div>
        <div class="d-flex justify-content-end">
          <div><button type="button" class="btn btn-primary" (click)="proceedYes()">Renew</button></div>
          <div><button type="button" class="btn btn-link" (click)="proceedCancel()">Cancel</button></div>
        </div>
    
    </div>
  </div>
</form>
</div>